import moment from 'moment'

const fromValueToDate = (val: string | null) => {
    let out = null
    switch(val) {
        case 'today':
            out = moment().startOf('day').toISOString()
        break
        case '7days':
            out = moment().subtract(7, 'days').startOf('day').toISOString()
        break
        case '30days':
            out = moment().subtract(30, 'days').startOf('day').toISOString()
        break
        case 'thisYear':
            out = moment().startOf('year').toISOString()
        break
        case 'lastYear':
            out = moment().subtract(1, 'years').startOf('year').toISOString()
        break
    }

    return out
}

export const filterBuilder = (
    objectFilter: string  | number | any[] | null,
    objectField: string,
    fromFilter: string | null,
    fromField: string
) => {
    let filter: any[] = []

    if (objectFilter && objectFilter !== '' && objectField !== '') {
        filter = [objectField, '=', objectFilter]
    }

    const fromDate = fromValueToDate(fromFilter)
    if (fromDate && fromField !== '' && fromFilter !== 'all') {  // with `all` don't apply from filter
        const from: any[] = [fromField, '>', new Date(fromDate)]

        if (filter.length) {
            filter = [filter, 'and', from]
        } else {
            filter = from
        }
    }

    return filter
}
